(function () {
    window.MDMeals = window.MDMeals || {};

    window.MDMeals.api = function (path, opts) {
        var root = typeof mdMealPrep !== 'undefined' ? mdMealPrep.restRoot : '';
        if (root && root.indexOf('http') === 0) {
            try {
                var ru = new URL(root);
                root = ru.pathname;
                if (root.slice(-1) !== '/') {
                    root += '/';
                }
            } catch (e) {}
        }
        var nonce = typeof mdMealPrep !== 'undefined' ? mdMealPrep.nonce : '';
        opts = opts || {};
        opts.credentials = 'same-origin';
        opts.headers = opts.headers || {};
        if (nonce) {
            opts.headers['X-WP-Nonce'] = nonce;
        }
        if (opts.body && typeof opts.body === 'object' && !(opts.body instanceof FormData)) {
            opts.headers['Content-Type'] = 'application/json';
            opts.body = JSON.stringify(opts.body);
        }
        return fetch(root + path, opts).then(function (r) {
            return r.text().then(function (t) {
                var j = {};
                try {
                    j = t ? JSON.parse(t) : {};
                } catch (e) {
                    j = {};
                }
                if (!r.ok) {
                    var err = new Error(j.message || j.code || String(r.status));
                    if (j.code) {
                        err.code = j.code;
                    }
                    throw err;
                }
                return j;
            });
        });
    };

    window.MDMeals.esc = function (s) {
        var d = document.createElement('div');
        d.textContent = s;
        return d.innerHTML;
    };

    /* Alert-strip dismiss lives in dev/js/modules/alert-strip.js (global app bundle). */
})();
